import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { PARSE_DATES } from '../tokens/parse-dates.token';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
    private static readonly isoDateRegex =
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+\-]\d{2}:\d{2})$/;

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const shouldParse = req.context.get(PARSE_DATES);

        if (!shouldParse) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            map((event: HttpEvent<unknown>) => {
                if (event instanceof HttpResponse) {
                    if (event.body === null || event.body === undefined) {
                        return event;
                    }

                    if (event.body instanceof Blob) {
                        return event;
                    }

                    const converted = this.convertDates(event.body);
                    return event.clone({ body: converted });
                }

                return event;
            })
        );
    }

    private convertDates(value: unknown): unknown {
        if (value === null || value === undefined) {
            return value;
        }

        if (typeof value === 'string') {
            if (DateInterceptor.isoDateRegex.test(value)) {
                const d = new Date(value);

                if (!Number.isNaN(d.getTime())) {
                    return d;
                }
            }

            return value;
        }

        if (Array.isArray(value)) {
            return value.map((v) => this.convertDates(v));
        }

        if (typeof value === 'object') {
            if (value instanceof Date) {
                return value;
            }

            const obj = value as Record<string, unknown>;
            const result: Record<string, unknown> = {};

            for (const key of Object.keys(obj)) {
                result[key] = this.convertDates(obj[key]);
            }

            return result;
        }

        return value;
    }
}
